import React from 'react';
import type {
    FilterGroupNewFilter,
    FilterProps,
    FiltersProps,
    QueryFilterAdapterModel,
    QueryFilterAdapterProps,
} from '@igp/shared/components/filter';
import {FilterGroupNew, withQueryFilter} from '@igp/shared/components/filter';
import {AalFilter} from '@igp/shared/features/bo-user-group';

import type {ReferralLinkConfigFilterKeys, ReferralLinkConfigFilterModel, ReferralLinkConfigFilterName} from '../types';

function ReferralLinkConfigFilters(props: Omit<FiltersProps<ReferralLinkConfigFilterModel, ReferralLinkConfigFilterName>, 'submitButton'>) {
    const filters: FilterGroupNewFilter<ReferralLinkConfigFilterModel, ReferralLinkConfigFilterName>[] = [
        {
            filterName: 'aal',
            modelField: 'aal',
            component: (props: FilterProps<string[]>) => <AalFilter {...props} filterBy="group_name" />,
            collapseOnMobile: false,
        },
    ];
    return <FilterGroupNew mode="update-on-change" allFilters={filters} {...props} />;
}

function ReferralLinkConfigQueryFiltersAdapter({
    model,
    onChange,
    ...props
}: Omit<QueryFilterAdapterProps<ReferralLinkConfigFilterKeys, ReferralLinkConfigFilterName, never>, 'submitButton'>) {
    const filterViewModel: ReferralLinkConfigFilterModel = {
        aal: model?.aal_group_name as string,
    };

    function handleChange(model: ReferralLinkConfigFilterModel) {
        const result: QueryFilterAdapterModel<ReferralLinkConfigFilterKeys, never> = {
            aal_group_name: model?.aal,
        };
        onChange(result);
    }
    return <ReferralLinkConfigFilters model={filterViewModel} onChange={handleChange} {...props} />;
}

export const ReferralLinkConfigQueryFilters = withQueryFilter<ReferralLinkConfigFilterKeys, ReferralLinkConfigFilterName, never>(
    ReferralLinkConfigQueryFiltersAdapter,
    {}
);
